
import * as React from 'react';
import InformationAlert from '../../../infrastructure/InformationAlert';

const NoInterestInformation = () => (
  <InformationAlert text="You currently have no interest in this package. Please register to do so" />
);

export default NoInterestInformation;